import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

// Selector claro / oscuro (preferencia de cada usuario)
export default function ThemeSwitch() {
  const { theme, setTheme } = useAuth();
  return (
    <div className="theme-switch" role="group" aria-label="Modo de color">
      <button type="button" className={theme === 'light' ? 'active' : ''} onClick={() => setTheme('light')}><Sun size={13} /> Claro</button>
      <button type="button" className={theme !== 'light' ? 'active' : ''} onClick={() => setTheme('dark')}><Moon size={13} /> Oscuro</button>
    </div>
  );
}
